import { render } from "./MapAssessor.vue?vue&type=template&id=2747d0ba&ts=true"
import script from "./MapAssessor.vue?vue&type=script&lang=ts"
export * from "./MapAssessor.vue?vue&type=script&lang=ts"

import "./MapAssessor.vue?vue&type=style&index=0&id=2747d0ba&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__